import React from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../components/components"
import { Rechnungsverlaeufe } from "../components/Rechnungsverlaeufe"
import { Rechnungsverlauf } from "../models/rechnungsverlauf"

export interface RechnungsverlaufProps {
    rechnungsverlaeufe: Rechnungsverlauf[]
}

export function RechnungsverlaufView() {
    const { t } = useTranslation()
    return (
        <>
            <Components.Collapsible title={t("rechnung.rechnungsverlauf.title")} collapsed={true}>
                <Rechnungsverlaeufe />
            </Components.Collapsible>
        </>
    )
}
